// On-screen "AGENT PLAYING" badge, shown while an agent has claimed the session.
const INDICATOR_ID = "ai-agent-indicator";
const STYLE_ID = "ai-agent-indicator-style";

// Swap for the agent icon (an <img>/<svg> string) once it's picked; null = red recording dot only.
const AGENT_ICON_HTML = null;
// Just below the game header (#header in hud.css is a fixed 150px tall).
const TOP_OFFSET_PX = 150 + 8;

const CSS = `
#${INDICATOR_ID} {
  position: fixed;
  top: ${TOP_OFFSET_PX}px;
  right: 8px;
  z-index: 100000;
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 3px 7px;
  border: 1.5px solid #e00000;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.6);
  color: #ff2a2a;
  font: bold 11px/1 sans-serif;
  letter-spacing: 0.08em;
  pointer-events: none;
  user-select: none;
}
/* Only while the game HUD is on screen - #header leaves the DOM when a game trial ends. */
body:not(:has(#header:not(.invisible))) #${INDICATOR_ID} {
  display: none;
}
#${INDICATOR_ID} .ai-agent-indicator-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #ff1a1a;
  box-shadow: 0 0 5px #ff1a1a;
}
#${INDICATOR_ID} .ai-agent-indicator-icon {
  display: flex;
  height: 14px;
}
#${INDICATOR_ID} .ai-agent-indicator-icon > * {
  height: 100%;
  width: auto;
}
/* Label stays steady; only the dot pulses, slow like a recording light. */
#${INDICATOR_ID} .ai-agent-indicator-dot {
  animation: ai-agent-indicator-pulse 2.4s ease-in-out infinite;
}
@keyframes ai-agent-indicator-pulse {
  50% { opacity: 0.3; }
}
`;

export function showAgentIndicator() {
  if (typeof document === "undefined" || document.getElementById(INDICATOR_ID)) return;

  if (!document.getElementById(STYLE_ID)) {
    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = CSS;
    document.head.appendChild(style);
  }

  const indicator = document.createElement("div");
  indicator.id = INDICATOR_ID;
  indicator.innerHTML = `
    <span class="ai-agent-indicator-dot"></span>
    ${AGENT_ICON_HTML ? `<span class="ai-agent-indicator-icon">${AGENT_ICON_HTML}</span>` : ""}
    <span class="ai-agent-indicator-label">AGENT PLAYING</span>
  `;
  document.body.appendChild(indicator);
}

export function hideAgentIndicator() {
  if (typeof document === "undefined") return;
  document.getElementById(INDICATOR_ID)?.remove();
}
